// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RecommendationsControlPage {
  padding-left: 281px;
  background: #EFF0F4;
  width: 100%;
  height: 100vh;
}
.RecommendationsControlPage .titleBlock {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
  background: #fff;
  padding-top: 43px;
  padding-left: 40px;
  padding-bottom: 27px;
}
.RecommendationsControlPage .titleBlock span {
  font-family: "Montserrat Regular";
  font-weight: 500;
  font-size: 24px;
}
.RecommendationsControlPage .collectionItem {
  margin-top: 100px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 50px;
  align-items: center;
}
.RecommendationsControlPage .collectionItem .carouselBlock {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.RecommendationsControlPage .collectionItem .restaurantCardContent {
  width: 240px;
  padding: 16px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}
.RecommendationsControlPage .collectionItem .restaurantCardContent:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}
.RecommendationsControlPage .collectionItem .restaurantCardContent .restaurantName {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #1890ff;
}
.RecommendationsControlPage .collectionItem .restaurantCardContent p {
  margin: 4px 0;
  font-size: 14px;
}
.RecommendationsControlPage .restaurantModalContent p {
  margin: 6px 0;
  font-size: 14px;
}
.RecommendationsControlPage .collectionHeader {
  display: flex;
  align-items: center;
  gap: 20px;
}
.RecommendationsControlPage .collectionHeader .editIcon {
  background-color: #d5d4d8;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/RecommendationsControlPage/RecommendationsControlPage.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AACR;AACQ;EACI,iCAAA;EACA,gBAAA;EACA,eAAA;AACZ;AAEI;EACI,iBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAAR;AAEQ;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAZ;AAGQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,eAAA;EACA,2CAAA;AADZ;AAGY;EACI,2BAAA;EACA,0CAAA;AADhB;AAIY;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAFhB;AAKY;EACI,aAAA;EACA,eAAA;AAHhB;AAQI;EACI,aAAA;EACA,eAAA;AANR;AASI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAPR;AASQ;EACI,yBAAA;AAPZ","sourcesContent":[".RecommendationsControlPage {\n    padding-left: 281px;\n    background: #EFF0F4;\n    width: 100%;\n    height: 100vh;\n\n    .titleBlock {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: left;\n        background: #fff;\n        padding-top: 43px;\n        padding-left: 40px;\n        padding-bottom: 27px;\n\n        span {\n            font-family: \"Montserrat Regular\";\n            font-weight: 500;\n            font-size: 24px;\n        }\n    }\n    .collectionItem {\n        margin-top: 100px;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        gap: 50px;\n        align-items: center;\n\n        .carouselBlock {\n            width: 100%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n        }\n\n        .restaurantCardContent {\n            width: 240px;\n            padding: 16px;\n            border-radius: 12px;\n            background: #fff;\n            box-shadow: 0 2px 12px rgba(0,0,0,0.08);\n            cursor: pointer;\n            transition: transform 0.2s, box-shadow 0.2s;\n\n            &:hover {\n                transform: translateY(-5px);\n                box-shadow: 0 6px 20px rgba(0,0,0,0.12);\n            }\n\n            .restaurantName {\n                font-size: 16px;\n                font-weight: 600;\n                margin-bottom: 8px;\n                color: #1890ff;\n            }\n\n            p {\n                margin: 4px 0;\n                font-size: 14px;\n            }\n        }\n    }\n\n    .restaurantModalContent p {\n        margin: 6px 0;\n        font-size: 14px;\n    }\n\n    .collectionHeader{\n        display: flex;\n        align-items: center;\n        gap: 20px;\n\n        .editIcon{\n            background-color: #d5d4d8;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"RecommendationsControlPage": `RecommendationsControlPage`,
	"titleBlock": `titleBlock`,
	"collectionItem": `collectionItem`,
	"carouselBlock": `carouselBlock`,
	"restaurantCardContent": `restaurantCardContent`,
	"restaurantName": `restaurantName`,
	"restaurantModalContent": `restaurantModalContent`,
	"collectionHeader": `collectionHeader`,
	"editIcon": `editIcon`
};
export default ___CSS_LOADER_EXPORT___;
